import { useEffect, useMemo } from 'react'

const useScrollSpy = (sectionIds = [], setSelectedMenu, options = {}) => {
  // Memoize the options to prevent unnecessary re-renders
  const memoizedOptions = useMemo(() => options, [options])

  // Memoize the sectionIds string to prevent unnecessary re-renders
  const sectionIdsKey = useMemo(() => sectionIds.join('-'), [sectionIds])

  useEffect(() => {
    if (
      !Array.isArray(sectionIds) ||
      sectionIds.length === 0 ||
      typeof setSelectedMenu !== 'function'
    ) {
      return
    }

    const observerOptions = {
      root: null,
      threshold: 0.3, // at least 60% of section should be visible
      rootMargin: '0px 0px -30% 0px',
      ...memoizedOptions,
    }

    const visibleSections = new Set()
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleSections.add(entry.target)
        } else {
          visibleSections.delete(entry.target)
        }
      })

      const topMost = [...visibleSections].sort(
        (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top,
      )[0]

      if (topMost) setSelectedMenu(topMost.id)
    }, observerOptions)

    // Observe valid DOM elements
    const elements = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean)

    elements.forEach((el) => observer.observe(el))

    return () => {
      observer.disconnect()
    }
  }, [sectionIdsKey, setSelectedMenu, memoizedOptions, sectionIds])
}

export default useScrollSpy
